"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Payout = void 0;
var Payout;
(function (Payout) {
    let status;
    (function (status) {
        status["UNKNOWN"] = "unknown";
        status["AWAITING_APPROVAL"] = "awaiting_approval";
        status["APPROVED"] = "approved";
        status["REJECTED"] = "rejected";
        status["PROCESSING"] = "processing";
        status["PAID"] = "paid";
        status["FAILED"] = "failed";
    })(status = Payout.status || (Payout.status = {}));
})(Payout = exports.Payout || (exports.Payout = {}));
